<div class="widget-header" [ngStyle]="setHeaderStyle()">
  <button type="button" class="close" aria-label="Close" [ngStyle]="setHeaderStyle()" (click)="close()">
    <span aria-hidden="true" class="close-description">{{'std.closeHere' | translate}} </span>
    <i class="material-icons close-icon icon-centered">close</i>
  </button>
  <h4 *ngIf="header" class="widget-header-title">{{header}}</h4>
</div>
